//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

import KitTours from './KitBlocks/KitTours.vue'
import KitInspiration from './KitBlocks/KitInspiration.vue'
import KitVenues from './KitBlocks/KitVenues.vue'
import KitLodging from './KitBlocks/KitLodging.vue'
import KitEvents from './KitBlocks/KitEvents.vue'

import slugify from 'slugify';

export default {
  props: {
    
  },
  components: {
    KitTours,
    KitInspiration,
    KitVenues,
    KitLodging,
    KitEvents
  },
  computed: {
    
  },
  watch: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      ui: {
        page: 1,
        per_page: 3,
      },
      blocks: blocks,
      tourSliderOptions: {
          initialIndex: 0,
          wrapAround: true,
          resize: true,
          setGallerySize: false
          // any options from Flickity can be used
      },
      fittyOptions: {
        minSize: 28,
        maxSize: 36,
      }
    }
  },
  mounted() {

    let self = this;



 

  },
  methods: {

    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
    getPadded(num, size) {
      var s = String(num);
      while (s.length < (size || 2)) {s = "0" + s;}
      return s;
    },
    
  }
}




// WEBPACK FOOTER //
// ./scripts/components/WelcomeKit.vue